﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260115
*/
'use strict';
import { getPromise } from './ctssJQuery.js';
import { bindSelect } from './ctssHtml.js'; 

const getAM_PM_Async = async () =>
    await getPromise({ url: 'Frequency/AM_PM_DDL' });

const getAM_PM_DDL_Async = async (params = {}) => {
    const listItems = await getAM_PM_Async();
    bindSelect({
        id: params.id ?? 'ddlAM_PM',
        items: listItems
    });
}

const getDaysOfWeekAsync = async () =>
    await getPromise({ url: 'Frequency/DaysOfWeekDDL' });

const getDaysOfWeekDDL_Async = async (params = {}) => {
    const listItems = await getDaysOfWeekAsync();
    bindSelect({
        id: params.id ?? 'ddlDaysOfWeek',
        items: listItems
    });
}

const getFrequenciesAsync = async () =>
    await getPromise({ url: 'Frequency' });

const getFrequencyDDL_Async = async (params) => {
    const listItems = await getFrequenciesAsync();
    bindSelect({
        id: params.id ?? 'ddlFrequency',
        items: listItems
    })
}    

const getHoursAsync = async () =>
    await getPromise({ url: 'Frequency/HoursDDL' });

const getHoursDDL_Async = async (params) => {
    const listItems = await getHoursAsync();
    bindSelect({
        id: params.id ?? 'ddlHours',
        items: listItems
    })
}

export {
    getAM_PM_Async,
    getAM_PM_DDL_Async,
    getDaysOfWeekAsync,
    getDaysOfWeekDDL_Async,
    getFrequenciesAsync,
    getFrequencyDDL_Async,
    getHoursAsync,
    getHoursDDL_Async
};
